import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ModuleCertificate } from './module-certificate.model';
import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';

export class ModuleCertificateStateModel extends EntityStateModel<ModuleCertificate> {
    usedTemplates?: SimpleCertificate[];
}
